import { PageHead } from "@/components/admin/page-head";
import { SitePromisesEditor } from "@/components/admin/site-promises-editor";

/**
 * Engagements commerciaux — ce que le site promet au visiteur.
 *
 * Écran à part : ces valeurs alimentent toutes les pages de la vitrine et le
 * calcul réel des frais de livraison. Les noyer au milieu des contenus
 * éditoriaux laissait croire qu'il s'agissait de simples textes.
 */
export function AdminCmsPromisesPage() {
	return (
		<>
			<PageHead
				title="Engagements commerciaux"
				sub="Retour, garantie, livraison offerte, moyens de paiement"
			/>
			<SitePromisesEditor />
		</>
	);
}
